const c = {
  name: "OauthUserExperience",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M23,14h-9v9c0,1.7,1.3,3,3,3h9v-9C26,15.3,24.7,14,23,14z M16,23v-7h7c0.5,0,1,0.5,1,1v7h-7
			C16.5,24,16,23.5,16,23z"/>
		<path class="st0" d="M16,3.5c-1.8,0.4-3.4,1.1-4.9,2C10.4,5,9.6,4.7,8.7,4.7c-2.2,0-4,1.8-4,4c0,0.9,0.3,1.7,0.8,2.4
			c-0.9,1.5-1.6,3.2-2,4.9C1.5,16.3,0,18,0,20c0,2,1.5,3.7,3.5,4c0.4,1.8,1.1,3.4,2,4.9c-0.5,0.7-0.8,1.5-0.8,2.4c0,2.2,1.8,4,4,4
			c0.9,0,1.7-0.3,2.4-0.8c1.5,0.9,3.2,1.6,4.9,2c0.3,2,1.9,3.5,4,3.5c2,0,3.7-1.5,4-3.5c1.8-0.4,3.4-1.1,4.9-2
			c0.7,0.5,1.5,0.8,2.4,0.8c2.2,0,4-1.8,4-4c0-0.9-0.3-1.7-0.8-2.4c0.9-1.5,1.6-3.2,2-4.9c2-0.3,3.5-1.9,3.5-4s-1.5-3.7-3.5-4
			c-0.4-1.8-1.1-3.4-2-4.9c0.5-0.7,0.8-1.5,0.8-2.4c0-2.2-1.8-4-4-4c-0.9,0-1.7,0.3-2.4,0.8c-1.5-0.9-3.2-1.6-4.9-2
			C23.7,1.5,22,0,20,0C18,0,16.3,1.5,16,3.5z M18,4c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2s-0.9,2-2,2C18.9,6,18,5.1,18,4z M16.3,5.5
			C16.9,7,18.3,8,20,8c1.7,0,3.1-1,3.7-2.5c1.4,0.4,2.7,0.9,3.9,1.6c-0.2,0.5-0.3,1-0.3,1.6c0,2.2,1.8,4,4,4c0.6,0,1.1-0.1,1.6-0.3
			c0.7,1.2,1.3,2.5,1.6,3.9C33,16.9,32,18.3,32,20c0,1.7,1,3.1,2.5,3.7c-0.4,1.4-0.9,2.7-1.6,3.9c-0.5-0.2-1-0.3-1.6-0.3
			c-2.2,0-4,1.8-4,4c0,0.6,0.1,1.1,0.3,1.6c-1.2,0.7-2.5,1.3-3.9,1.6C23.1,33,21.7,32,20,32c-1.7,0-3.1,1-3.7,2.5
			c-1.4-0.4-2.7-0.9-3.9-1.6c0.2-0.5,0.3-1,0.3-1.6c0-2.2-1.8-4-4-4c-0.6,0-1.1,0.1-1.6,0.3c-0.7-1.2-1.3-2.5-1.6-3.9
			C7,23.1,8,21.7,8,20c0-1.7-1-3.1-2.5-3.7c0.4-1.4,0.9-2.7,1.6-3.9c0.5,0.2,1,0.3,1.6,0.3c2.2,0,4-1.8,4-4c0-0.6-0.1-1.1-0.3-1.6
			C13.6,6.4,14.9,5.8,16.3,5.5z M20,34c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2C18,34.9,18.9,34,20,34z M29.3,8.7
			c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S29.3,9.8,29.3,8.7z M8.7,29.3c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2
			C6.7,30.2,7.6,29.3,8.7,29.3z M34,20c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2C34.9,22,34,21.1,34,20z M4,18
			c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2s-2-0.9-2-2C2,18.9,2.9,18,4,18z M29.3,31.3c0-1.1,0.9-2,2-2s2,0.9,2,2c0,1.1-0.9,2-2,2
			S29.3,32.4,29.3,31.3z M8.7,6.7c1.1,0,2,0.9,2,2s-0.9,2-2,2c-1.1,0-2-0.9-2-2S7.6,6.7,8.7,6.7z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as OauthUserExperience
};
